import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useComments from './hooks/useComments';
import { Button } from 'ncoded-component-library';
import Comment from 'components/Comment';

import './ProfileComments.styles.scss';

type ProfileCommentsProps = {
  candidateId: string;
  schoolGroupId: string;
  className?: string;
};

const ProfileComments: React.FC<ProfileCommentsProps> = (props) => {
  const { className, candidateId, schoolGroupId } = props;

  const { comments, haveMore, loadMore } = useComments(
    candidateId,
    schoolGroupId,
  );

  const { t } = useTranslation();

  const classes = classNames('searchality-profile-comments', className);

  return (
    <div className={classes}>
      <p className="title">{t('teamComments')}</p>
      <div className="searchality-profile-comments__comments">
        {comments?.map((el, index) => (
          <Comment key={index} comment={el} />
        ))}
        {haveMore && (
          <Button onClick={loadMore} variant="link">
            {t('loadMore')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ProfileComments;
